<div class="container-fluid">
    <div class="row periodo-stats">
        <div class="row">
            <div class="col-8">Periodo Analizado</div>
            <div class="col-2">{{contadorperiodos}}</div>
        </div>
        <div class="row mt-2">
            <div class="col-8">Periodo Que Cumplen el Rango de Volatilidad</div>
            <div class="col-2">{{contadorVolatilidad}}</div>
        </div>
        <div class="row mt-2">
            <div class="col-8">Periodo Donde hay Rango de Variacion Mayor a {{Modelformdata.rangoPorcentualEvaluar}} </div>
            <div class="col-2">{{variacionMayorPositivo}}</div>
        </div>
         <div class="row mt-2">
            <div class="col-8">Periodo Donde hay Rango de Variacion Menor a -{{Modelformdata.rangoPorcentualEvaluar}} </div>
            <div class="col-2">{{variacionMenorNegativo}}</div>
        </div>
        <div class="row mt-2">
            <div class="col-8">Periodo Donde hay Rango de Variacion Menor a {{Modelformdata.rangoPorcentualEvaluar}} </div>
            <div class="col-2">{{variacionMenorPositivo}}</div>
        </div>
        <div class="row mt-2">
            <div class="col-8">Periodo Donde hay Rango de Variacion Mayor a -{{Modelformdata.rangoPorcentualEvaluar}} </div>
            <div class="col-2">{{variacionMayorNegativo}}</div>
        </div>
       
        <div class="row mt-2">
            <div class="col-8">Periodo al que Fecha fin del Periodo el Rango es Mayor </div>
            <div class="col-2">{{variacionMayorFF}}</div>
        </div>
        <div class="row mt-2">
            <div class="col-8">Periodo al que Fecha fin del Periodo el Rango es Menor</div>
            <div class="col-2">{{variacionMenorFF}}</div>
        </div>

    </div>
    <h6 class="etiquetas mt-2 text-center">Clasificacion Porcentaje a Fecha Fin Periodo que Cumplen con el Rango de
        Volatilidad</h6>
    <div class="row mt-2">
        <div class="col-6">
            <cdk-virtual-scroll-viewport #viewportPositivos id="viewportPositivos" item [appendOnly]="false"
                [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
                <table cdk-table [dataSource]="lvaData" class="table-striped tableStyle">

                    <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
                    <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
                        [ngClass]="{'selected': row === filaSeleccionada}"></tr>
                    <ng-container *ngFor="let tablecol of tableColumns">

                        <ng-container [cdkColumnDef]="tablecol.id">
                            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
                                {{tablecol.name}}
                            </th>
                            <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                          'entrada': item[tablecol.id] === 'ENTRADA',
                                                          'numero-positivo': item[tablecol.id] > 0,
                                                          'numero-negativo': item[tablecol.id] < 0
                                                          }">
                                <ng-container *ngIf="tablecol.isString">
                                    {{item[tablecol.id]}}
                                </ng-container>
                                <ng-container *ngIf="tablecol.isDate">
                                    {{item[tablecol.id] | smartDate }}
                                </ng-container>
                                <ng-container *ngIf="tablecol.isNumber">
                                    {{item[tablecol.id] |number:'1.2-2'}}
                                </ng-container>
                            </td>
                        </ng-container>
                    </ng-container>
                </table>
            </cdk-virtual-scroll-viewport>
            <div class="row">
                <!--          <div class="col-4">

                </div> -->
                <div class="col-12" style="padding-bottom: 0.5rem; padding-top: 0.5rem;">
                    <input type="number" name="" id="" step="0.05" [(ngModel)]="clasificacionporcentual" placeholder="Clasificacion Porcentual">
                    <button class="fw-semibold botones ms-1" (click)="OpenClasificacion()">
                        Clasificacion Porcentual del Periodo
                    </button>
                </div>
            </div>
        </div>
        <div class="col-6">
            <cdk-virtual-scroll-viewport #viewportNegativos id="viewportNegativos" item [appendOnly]="false"
                [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
                <table cdk-table [dataSource]="lvnData" class="table-striped tableStyle">

                    <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
                    <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
                        [ngClass]="{'selected': row === filaSeleccionada}"></tr>
                    <ng-container *ngFor="let tablecol of tableColumns2">

                        <ng-container [cdkColumnDef]="tablecol.id">
                            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
                                {{tablecol.name}}
                            </th>
                            <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                                      'entrada': item[tablecol.id] === 'ENTRADA',
                                                                      'numero-positivo': item[tablecol.id] > 0,
                                                                      'numero-negativo': item[tablecol.id] < 0
                                                                      }">
                                <ng-container *ngIf="tablecol.isString">
                                    {{item[tablecol.id]}}
                                </ng-container>
                                <ng-container *ngIf="tablecol.isDate">
                                    {{item[tablecol.id] | smartDate }}
                                </ng-container>
                                <ng-container *ngIf="tablecol.isNumber">
                                    {{item[tablecol.id] |number:'1.2-2'}}
                                </ng-container>
                            </td>
                        </ng-container>
                    </ng-container>
                </table>
            </cdk-virtual-scroll-viewport>
            <div class="row">
                <!--          <div class="col-4">
         
                         </div> -->
                <div class="col-12" style="padding-bottom: 0.5rem; padding-top: 0.5rem;">
                    <input type="text" name="" id="">
                    <button class="fw-semibold botones ms-1" (click)="OpenExclusion()">
                        Exclusion de Periodo con Eventos
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>